import { baseFetch } from "./apiClient";

/** Upload a profile portrait through the owned-media presigned flow. */
export const uploadProfilePhoto = async (file, { signal } = {}) => {
  const presign = await baseFetch({
    url: "/v1/app/upload/presign",
    method: "POST",
    signal,
    body: {
      fieldName: "photo",
      mimetype: file.type,
      size: file.size,
      originalName: file.name,
    },
  });
  const { mode, url, fields, key, uploadToken } = presign.data;
  if (mode && mode !== "single") throw new Error("Unsupported upload mode");

  const form = new FormData();
  for (const [field, value] of Object.entries(fields ?? {})) {
    form.append(field, value);
  }
  form.append("file", file);
  const stored = await fetch(url, { method: "POST", body: form, signal });
  if (!stored.ok) throw new Error("Upload failed");

  const completed = await baseFetch({
    url: "/v1/app/upload/presign/complete",
    method: "POST",
    signal,
    body: { key, uploadToken },
  });
  return completed.data.url;
};
